var Vue = require('vue').default
var App = require('./App')
var httpr = require('../vendor/httpr').default
import './main.css'
import eventBus from '../pic_find_holes_guide/utils/event_bus.js'
import game_config from '../pic_find_holes_guide/utils/game_config.js'

Vue.use(httpr)

Vue.prototype.$eventBus = eventBus
Vue.prototype.$game_config = game_config


// Vue.config.devtools = true;
// Vue.config.performance = true;
// // 开发环境强制开启devtools
// if (process.env.NODE_ENV === 'development') {
// }

var app = new Vue({
    el: '#app',
    render: h => h(App),
}).$mount("#app")
